export default __webpack_public_path__ + "static/media/VSProfile.f0f80a9f.png";